<template>
  <q-scroll-area
    :style="`height: ${listHeight}; width: 100%; padding: 0 16px;`"
    :bar-style="{
      borderRadius: '1px',
      background: 'black',
      opacity: 0,
      width: '5px',
    }"
    :thumb-style="{
      right: '5px',
      borderRadius: '5px',
      background: 'black',
      width: '5px',
      opacity: 0.2,
    }"
    id="overlay-dates-list"
  >
    <q-list>
      <template v-for="(expansionItem, expansionIndex) of data.list">
        <q-expansion-item
          class="expansion-overlay q-pt-lg"
          dense
          dense-toggle
          default-opened
          switch-toggle-side
          expand-icon="expand_less"
          :key="`${expansionIndex}`"
        >
          <template #header>
            <div class="full-width row items-center justify-center">
              <div
                class="label q-mr-auto"
                v-if="typeof expansionItem.label === 'string'"
              >
                {{ expansionItem.label }}
              </div>
              <template v-else>
                <div
                  :class="[
                    'label',
                    { 'q-ml-auto secondary q-pt-xs': index },
                    { 'q-mr-auto': !index },
                  ]"
                  v-for="(item, index) in expansionItem.label"
                  :key="index"
                >
                  {{ item }}
                </div>
              </template>
            </div>
          </template>

          <q-separator />
          <template v-for="(rowItem, rowIndex) of expansionItem.values">
            <q-item
              v-bind="{
                class: 'row-item',
                clickable: !!rowItem.clickable,
                to: rowItem.clickable
                  ? {
                      path: rowItem.clickable.to.path,
                      query: rowItem.clickable.to.query,
                    }
                  : null,
                dense: true,
              }"
              :key="`${expansionIndex}-${rowIndex}`"
            >
              <div
                class="row items-start"
                :set="(icon = getRowIcon(expansionItem, rowItem))"
              >
                <q-icon
                  class="q-pr-sm q-pt-xs"
                  size="16px"
                  color="secondary"
                  :name="icon"
                  v-if="icon"
                />
              </div>

              <div class="col row items-start justify-between no-wrap">
                <div
                  class="column justify-center items-start"
                  v-for="(content, contentIndex) in rowItem.content"
                  :key="`content-${expansionIndex}-${rowIndex}-${contentIndex}`"
                >
                  <template v-if="!(content instanceof Array)">
                    <div
                      :class="[
                        'text-grey-9 row-text q-pl-xs full-width',
                        content.text.class,
                      ]"
                    >
                      {{ content.text.value }}
                    </div>
                    <div
                      :class="[
                        'text-grey-8 row-caption q-pl-xs full-width',
                        content.caption.class,
                      ]"
                      v-if="content.caption.value"
                    >
                      {{ content.caption.value }}
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="column justify-center items-end full-width"
                      v-for="(childrenContent, childrenIndex) in content"
                      :key="`content-${expansionIndex}-${rowIndex}-${contentIndex}-${childrenIndex}`"
                    >
                      <div
                        :class="[
                          'text-grey-9 row-text q-pl-xs',
                          childrenContent.text.class,
                          { children: childrenIndex },
                        ]"
                      >
                        {{ childrenContent.text.value }}
                      </div>
                      <div
                        :class="[
                          'text-grey-8 row-caption q-pl-xs',
                          childrenContent.caption.class,
                          { children: childrenIndex },
                        ]"
                        v-if="childrenContent.caption.value"
                      >
                        {{ childrenContent.caption.value }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </q-item>
            <q-separator
              :key="`separator-${expansionIndex}-${rowIndex}`"
              v-if="rowIndex !== expansionItem.values.length - 1"
            />
          </template>
        </q-expansion-item>
        <q-separator :key="`separator-${expansionIndex}`" />
      </template>
    </q-list>
  </q-scroll-area>
</template>

<script>
export default {
  name: "DOverlayList",
  props: {
    listHeight: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getRowIcon(section, row) {
      if (section.icon) {
        return section.icon;
      }

      if (row.icon) {
        return row.icon;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
